<template>
  <div>
    <vs-popup :active.sync="showPurchasePopup" title="Modification du Prix">
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input
            class="w-full"
            placeholder="Prix"
            label="Prix"
            v-model="modifiedPurchase.recurrence_price"
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button class="mt-2" @click="saveModifiedPurchase()">Enregistrer</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir valider ces achats ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="saveAllPurchases()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="declinePurchase()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="showLeavePopup" title="Êtes-vous sûr de vouloir quitter cette page sans enregistrer ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="leaveAnyways()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="doNotLeave()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-table :data="displayedPurchases" class="mt-4" stripe auto-resize>
    <template slot="thead">
        <vs-th>Société</vs-th>
        <vs-th>Numéro de contrat</vs-th>
        <vs-th>Service</vs-th>
        <vs-th>Prestataire</vs-th>
        <vs-th>Prix Achat</vs-th>
        <vs-th>Date Achat</vs-th>
        <vs-th>Récurrence</vs-th>
        <vs-th>Facturable</vs-th>
        <vs-th>Commentaire</vs-th>
        <vs-th>Acheté ?</vs-th>

    </template>

    <template>
        <vs-tr :key="index" v-for="(purchase, index) in displayedPurchases">
        <vs-td :data="purchase.contract_society_id">{{ getSocietyIdToName(purchase.contract_society_id) }}</vs-td>
        <vs-td :data="purchase.contract_id">{{ purchase.contract_id }}</vs-td>
        <vs-td :data="purchase.service_id">{{ getServiceIdToName(purchase.service_id )}}</vs-td>
        <vs-td :data="purchase.users_id"> {{ getProviderIdToName(purchase.users_id) }}</vs-td>
        <vs-td :data="purchase.price"> {{ purchase.recurrence_id ? purchase.recurrence_price : purchase.price }}</vs-td>
        <vs-td>
          <vx-tooltip text="Modifier le prix" position="top">
            <vs-button
                size="large"
                color="primary"
                type="flat"
                icon-pack="feather"
                icon="icon-edit-2"
                @click="updatePurchase(purchase)"
            ></vs-button>
          </vx-tooltip>
        </vs-td>
        <vs-td :data="purchase.bought_at"> {{ purchase.recurrence_date ? getDateToFrenchFormat(formatDate(purchase.recurrence_date)) : getDateToFrenchFormat(formatDate(purchase.bought_at))  }}</vs-td>
        <vs-td :data="purchase.recurrence"> {{ getPurchaseFrequency(purchase.recurrence) }}</vs-td>
        <vs-td :data="purchase.is_billable"> {{ getUserDashboardAccess(purchase.is_billable) }}</vs-td>
        <vs-td :data="purchase.commentary"> {{ purchase.commentary }}</vs-td>
        <vs-td>
          <div class="switch-toggle switch-3 switch-candy switch-candy-blue">
            <input :id="purchase.recurrence_id + 'off'" :name="purchase.recurrence_id + 'state-d'" type="radio" checked="" value=2 v-model="purchase.recurrence_is_paid" />
            <label :for="purchase.recurrence_id + 'off'" @click="checkChanges(purchase, 2)">Non</label>

            <input :id="purchase.recurrence_id + 'null'" :name="purchase.recurrence_id + 'state-d'" type="radio" checked="checked" value=0  v-model="purchase.recurrence_is_paid" />
            <label :for="purchase.recurrence_id + 'null'" class="disabled" @click="checkChanges(purchase, 0)">&nbsp;</label>

            <input :id="purchase.recurrence_id + 'on'" :name="purchase.recurrence_id + 'state-d'" type="radio" value=1 v-model="purchase.recurrence_is_paid" />
            <label :for="purchase.recurrence_id + 'on'" @click="checkChanges(purchase, 1)">Oui</label>

            <a></a>
          </div>
        </vs-td>
        </vs-tr>
	
    </template>
    </vs-table>
  </div>
</template>

<script>
// import Vue from 'vue';
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Purchase from "@/entities/Purchase";

import "@/assets/css/toggle-switch.css";

export default {
	name: "CheckRecurringPurchasesTable",
	props: {
		purchases: Array,
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			newPrice: 0,
			showPurchasePopup: false,
			showValidationPopup: false,
			showLeavePopup: false,
			leaveAnyway: false,
			selectedPurchase: Purchase.getFormFields(),
			modifiedPurchase: Purchase.getFormFields(),
			displayedPurchases: [],
			changesHappened: false
		};
	},
	created() {
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
		this.displayedPurchases = JSON.parse(JSON.stringify(this.purchases));
	},
	mounted() {
	},

	computed: {
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		}
	},
	watch: {
		purchases: function(){
			//console.log("purchases watch");
			this.displayedPurchases = JSON.parse(JSON.stringify(this.purchases));
		},
		displayedPurchases: function(){
			// this.checkChanges()
		}
	},

	methods: {

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined && service.name != undefined){
				service_name = service.name;
			}
			return service_name;
		},

		getSocietyIdToName(society_id){
			let society_name = "";
			let society = this.societies.find(society => society.id == society_id);
			if(society != undefined && society.name != undefined){
				society_name = society.name;
			}
			return society_name;
		},

		getProviderIdToName(provider_id){
			let provider_name = "";
			let provider = this.providers.find(provider => provider.id == provider_id);
			if(provider != undefined && provider.society != undefined){
				provider_name = provider.society;
			}
			return provider_name;
		},

		formatDate(date_input){
			if(date_input && date_input.length > 10){
				return date_input.substring(0, 10);
			}
			else{
				return date_input;
			}
		},
		getAllServices(){
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties(){
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders(){
			this.$store.dispatch("getAllProviders");
		},

		leaveAnyways(){
			this.showLeavePopup = false;
			this.changesHappened = false;
			this.$router.go(-1);
		},
		doNotLeave(){
			this.showLeavePopup = false;
		},
		beforeRouteLeave() { // CHANGER NOM ET ADAPTER
			//console.log("Before Route Leave Function");
			if(this.changesHappened) {
				this.showLeavePopup = true;
				return false;
			}
			else{
				return true;
			}
		},
		checkChanges(purchase, purchase_state){
			//console.log("checkChanges");
			purchase.recurrence_is_paid = purchase_state;
			//console.log(purchase.recurrence_is_paid);
			if(purchase_state == "1" || purchase_state == "2"){
				this.changesHappened = true;
			}

			/*
			 * this.changesHappened = false
			 * for(let purchase of this.displayedPurchases){
			 *   if(purchase.recurrence_is_paid == 1 || purchase.recurrence_is_paid == 2){
			 *     this.changesHappened = true
			 *   }
			 * }
			 */
		},

		saveAllPurchases(){
			//console.log("saveAllPurchases");
			for(let purchase of this.displayedPurchases){
				if(purchase.recurrence_is_paid == 1 || purchase.recurrence_is_paid == 2){
					purchase.recurrence_is_check = 1;
					purchase.recurrence_is_paid = purchase.recurrence_is_paid == 2 ? 0 : purchase.recurrence_is_paid;
					//console.log(purchase.recurrence_id);
					this.selectedPurchase.recurrence_is_check = true;
					Purchase.updateRecurringPurchase(purchase, (err, res) => {
						if(err){
							//console.log(err);
							this.$vs.notify({title: "Echec", text: "Les achats n'ont pas été validés."});
						}
						if(res){
							//console.log(res);
							this.$vs.notify({title: "Succès", text: "Achats validés avec succès."});
							this.showValidationPopup = false;
							this.changesHappened = false;
							this.$emit("modify-purchase");
						}
					});
				}
			}
		},

		savePurchase(){
			this.showValidationPopup = true;
			/*
			 * if(purchase.recurrence_is_paid == 0){
			 *   this.selectedPurchase = purchase
			 *   this.showValidationPopup = true
			 * }else{
			 *   purchase.recurrence_is_check = true;
			 *   Purchase.updateRecurringPurchase(purchase, (err, res) => {
			 *     if(err){
			 *       //console.log(err)
			 *       this.$vs.notify({title:'Echec',text:"L'achat n'a pas été validé."})
			 *     }
			 *     if(res){
			 *       //console.log(res)
			 *       this.$vs.notify({title:'Succès',text:"Achat validé avec succès."})
			 *       this.$emit('modify-purchase')
			 *     }
			 *   })
			 * }
			 */
		},

		acceptPurchase(){
			this.selectedPurchase.recurrence_is_check = true;
			Purchase.updateRecurringPurchase(this.selectedPurchase, (err, res) => {
				if(err){
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été validé."});
				}
				if(res){
					//console.log(res);
					this.$vs.notify({title: "Succès", text: "Achat validé avec succès."});
					this.$emit("modify-purchase");
					this.showValidationPopup = false;
				}
			});
		},

		declinePurchase(){
			this.$vs.notify({title: "Abandon", text: "La validation de l'achat a été abandonnée."});
			this.showValidationPopup = false;
		},

		saveModifiedPurchase(){
			//  UPDATE RECURRING PURCHASE PRICE
			Purchase.updateRecurringPurchase(this.modifiedPurchase, (err, res) => {
				if(err){
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été modifié."});
				}
				if(res){
					//console.log(res);
					// this.$emit('modify-purchase')
					this.updatePurchaseFields();
					this.$vs.notify({title: "Succès", text: "Achat modifié avec succès."});
					this.showPurchasePopup = false;
				}
			});
		},

		updatePurchase(purchase){
			//POPUP
			this.selectedPurchase = null;
			this.modifiedPurchase = null;
			this.selectedPurchase = purchase;
			this.modifiedPurchase = JSON.parse(JSON.stringify(purchase));
			this.showPurchasePopup = true;
		},

		updatePurchaseFields(){
			for(let key in this.selectedPurchase) {
				if(this.modifiedPurchase[key] != this.selectedPurchase[key]){
					this.selectedPurchase[key] = this.modifiedPurchase[key];
				}
			}
		},

		renewPurchase(purchaseId){
			this.$emit("renew-purchase", purchaseId);
		}
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.switch-toggle {
  width: 10em;
}

.switch-toggle label:not(.disabled) {
  cursor: pointer;
}
</style>
